<template>
  <Card title="登录设置" class="app-list">
    <div class="content">
      <Form
        autocomplete="off"
        class="form"
        hide-required-mark
        label-position="left"
        ref="form"
        :model="form"
        :rules="rule"
        :label-width="80"
      >
        <FormItem label="旧密码" prop="oldPassword">
          <Input type="password" password v-model="form.oldPassword" />
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input type="password" password v-model="form.newPassword" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('form')">提交</Button>
        </FormItem>
      </Form>
    </div>
  </Card>
</template>

<script>
import { changePassword } from "@/service/api.js";
export default {
  data() {
    return {
      form: {},
      rule: {
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          let params = {
            old_password: this.form.oldPassword,
            new_password: this.form.newPassword,
          };

          console.log(params, "params");
          changePassword(params)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$Message.success({
                  content: res.data.msg || "修改成功！",
                  duration: 3,
                  background: true,
                });
                this.$refs[name].resetFields();
                this.$router.push("/login");
              } else {
                this.$Message.error({
                  duration: 3,
                  background: true,
                  content: res.data.msg || "操作失败！",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$Message.error({
                background: true,
                content: "提交失败!",
                duration: 3,
              });
            });
        } else {
          this.$Message.error({
            background: true,
            content: "表单内容不正确,请检查表单内容！",
            duration: 3,
          });
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  .content {
    // padding: 50px;
    padding: 20px;
    background-color: #fff;
    border-radius: 3px;
    // box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    .form {
      width: 350px;
    }
  }
}
</style>